import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    strict: true, // 严格模式
    state: {
        userType: localStorage.getItem('userType'),   //  用户权限 1管理员 0普通用户
        userId: "",
        token: "",
        userName: localStorage.getItem('userName'),
        adminUserIds: ["7042b266a3b542feb78d1e646b6bc74a", "ab678da438da4528ad549f1429d759d1", "38a497719df645afb847c315bfcb6be6", "bcf3a3f6277e496ebdcececc8f5b4538", "813f4c3ad709464fbbea279ea684c7f4", "0240ec963ae447599e172f8db009fdbf", "d905715d086c41e696192247062b4615", "1de9f836f3ac4e33bda5013041c543e8", "09c673c1dda74c969c343192a4e3ee3a", "ca1ca293d05442ebb1dc7c7e714b64e5"],
        // 定位信息
        gpsState: {
            area: "",
            city: "",
            cityCode: ""
        },
        // 成因分析数据
        causeAnalysisData: [],
        // 成因分析选择
        causeAnalysisSelect: null,
        secondSelectData: null,
        resourceDetailsData: null,
        saveRouter: null,
        saveNowDate: null,
        // 城市检测数据
        cityListData: [],
        cityListDataSelect: null,

        //  底部公共信息参数
        address: '',  // 地址
        signature: '', // 监制
        post: '',     //  邮编


        VOCTagsList: [],   // VOC系统tags
        dataAnalysedTagsList: [],   // 数据分析系统tags
        DSTTagsList: [],   // 天蓝卫士系统tags

        optionCityList:[],   //  可选城市列表,用于新建报告,与城市切换

    },
    mutations: {
        updatedataAnalysedTagsList(state, dataAnalysedTagsList) {
            state.dataAnalysedTagsList = dataAnalysedTagsList;
        },
        updateVOCTagsList(state, VOCTagsList) {
            state.VOCTagsList = VOCTagsList;
        },
        updateDSTTagsList(state, DSTTagsList) {
            state.DSTTagsList = DSTTagsList;
        },
        updateAddress(state, address) {
            state.address = address;
        },
        updateSignature(state, signature) {
            state.signature = signature;
        },
        updatePost(state, post) {
            state.post = post;
        },
        updateUserType(state, userType) {
            state.userType = userType;
            localStorage.setItem('userType',userType)
        },
        updateUserId(state, userId) {
            state.userId = userId;
        },
        updateToken(state, token) {
            state.token = token;
        },
        updateUserName(state, userName) {
            state.userName = userName;
        },
        updateGpsState(state, data) {
            state.gpsState = data;
        },
        updateCauseAnalysisData(state, data) {
            state.causeAnalysisData = data;
        },
        updateCityListData(state, data) {
            state.cityListData = data;
        },
        updateCauseAnalysisSelect(state, menuId) {
            let data = state.causeAnalysisData;
            for (let i = 0; i < data.length; i++) {
                if (data[i].menuId == menuId) {
                    state.causeAnalysisSelect = data[i];
                    return
                }
            }
        },
        updateCityListDataSelect(state, menuId) {
            let data = state.cityListData;
            for (let i = 0; i < data.length; i++) {
                if (data[i].menuId == menuId) {
                    state.cityListDataSelect = data[i];
                    return
                }
            }
        },
        updateResourceDetailsData(state, menuId) {
            if (typeof(menuId) === "object") {
                let id = menuId.menuId;
                let data = state.cityListDataSelect.children;
                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < data[i].children.length; j++) {
                        if (data[i].children[j].menuId == id) {
                            state.resourceDetailsData = data[i].children[j];
                            return
                        }
                    }
                }
                return;
            }
            let data = state.causeAnalysisSelect.children;
            if (state.secondSelectData) {
                data = state.secondSelectData.children;
                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < data[i].children.length; j++) {
                        if (data[i].children[j].menuId == menuId) {
                            state.resourceDetailsData = data[i].children[j];
                            return
                        }
                    }
                }
            } else {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].menuId == menuId) {
                        state.resourceDetailsData = data[i];
                        return
                    }
                }
            }

        },
        updateSecondSelectData(state, menuId) {
            if (!menuId) {
                state.secondSelectData = null;
                return;
            }
            let data = state.causeAnalysisSelect.children;
            for (let i = 0; i < data.length; i++) {
                if (data[i].menuId == menuId) {
                    state.secondSelectData = data[i];
                    return
                }
            }
        },
        updateSaveRouter(state, router) {
            state.saveRouter = router;
        },
        updateSaveNowDate(state, date) {
            state.saveNowDate = date;
        },
        updateoptionCityList(state, optionCityList) {
            state.optionCityList = optionCityList;
        }
    },
    getters: {
        getUserId: state => {
            return state.userId
        },
        getToken: state => {
            return state.token
        },
        getUserName: state => {
            return state.userName
        },
        getGpsState: state => {
            return state.gpsState;
        },
        getCauseAnalysisData: state => {
            return state.causeAnalysisData;
        },
        getCityListData: state => {
            return state.cityListData;
        },
        getCauseAnalysisSelect: state => {
            return state.causeAnalysisSelect;
        },
        getCityListDataSelect: state => {
            return state.cityListDataSelect;
        },
        getResourceDetailsData: state => {
            return state.resourceDetailsData;
        },
        getSecondSelectData: state => {
            return state.secondSelectData;
        },
        getSaveRouter: state => {
            return state.saveRouter
        },
        getSaveNowDate: state => {
            return state.saveNowDate
        }
    },
    actions: {
        loginOut() {
            // console.log(11111111111111111)
        }
    }

})
